import { Card } from "react-bootstrap";
import styled from "styled-components";

export const Check = styled(Card) <any>`
  width: 100%;
  border: none;
  zoom: 0.9;
  padding: 0;
  margin: 0;
  h5
  {
    color: ${({ theme }) => theme.black.dark};
    /* font-family: sans-serif; */
    b {
      /* font-family: sans-serif; */
      color: ${({ theme }) => theme.black.dark};
    }
  }
  p {
    /* display: flex;
    justify-content: space-between; */
    color: ${({ theme }) => theme.black.dark};
    /* font-family: sans-serif; */
    b {
      /* font-family: sans-serif; */
      color: ${({ theme }) => theme.black.dark};
    }
  }
  .checkImage {
      max-width: 150px;
      width: auto;
      height: 100px;
      margin-left: auto;
      margin-right: auto;
      object-fit: cover;
    } 
    .text-check{
      font-size: 11px;
      font-weight: 700 !important;
      color: "#000";
      word-break: "break-word";
      white-space: "normal";
      overflow-wrap: "break-word";
    }
`;

export const HoverStyle = styled.div`
  /* padding: 15px; */
  width: 40px;
  height: 40px;
  background-color: ${({ theme }) => theme.background.main};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: ${({ theme }) => theme.secondary.light};
  }
`;
